import {Component, Input, OnInit} from '@angular/core';
import {FlashMessage} from '../model/flashMessage';

@Component({
    selector: 'app-flash-message',
    templateUrl: './flash-message.component.html',
    styleUrls: ['./flash-message.component.css'],
    standalone: false
})
export class FlashMessageComponent implements OnInit {

  @Input()
  message: FlashMessage;

  constructor() { }

  ngOnInit() {
  }

}
